// =============================================================================
// Cache del catálogo para vender OFFLINE. Baja catálogo+stock (catalog_list) y
// el mapa de códigos de barra (select con RLS), y los guarda en Dexie. El POS,
// sin red, resuelve el pistoleo contra esta cache.
// =============================================================================
import { db, type CachedProduct } from "./db";
import { catalog } from "../api";
import { supabase } from "../supabase";

/** Refresca la cache del catálogo de una sucursal. Llamar online (al abrir POS
 *  y periódicamente). Si no hay red, no hace nada (conserva lo cacheado). */
export async function refreshCatalogCache(branchId: string): Promise<number> {
  if (!navigator.onLine) return 0;

  // 1. Catálogo + stock + presentaciones/precios.
  const items = await catalog.list(branchId, undefined, 1000, 0);

  // 2. Códigos de barra por presentación (RLS filtra al tenant).
  const unitIds = items.flatMap((p) => p.units.map((u) => u.product_unit_id));
  const codesByUnit = new Map<string, string[]>();
  if (unitIds.length > 0) {
    const { data } = await supabase.from("barcodes").select("product_unit_id, code").in("product_unit_id", unitIds);
    for (const row of (data ?? []) as { product_unit_id: string; code: string }[]) {
      const arr = codesByUnit.get(row.product_unit_id) ?? [];
      arr.push(row.code);
      codesByUnit.set(row.product_unit_id, arr);
    }
  }

  // 3. Volcar a Dexie (reemplaza la cache de esta sucursal).
  const rows: CachedProduct[] = items.map((p) => ({
    key: `${branchId}:${p.id}`,
    branchId,
    productId: p.id,
    sku: p.sku,
    name: p.name,
    itbmsRate: p.itbms_rate,
    qtyAvailable: p.qty_available,
    units: p.units.map((u) => ({ productUnitId: u.product_unit_id, factor: u.factor, price: u.price })),
    barcodes: p.units.flatMap((u) => codesByUnit.get(u.product_unit_id) ?? []),
    cachedAt: Date.now(),
  }));

  await db.transaction("rw", db.catalog, async () => {
    await db.catalog.where({ branchId }).delete();
    await db.catalog.bulkPut(rows);
  });
  return rows.length;
}
